import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Role from "../views/Role.vue";
import Video from "../views/Video.vue";
import News from "../views/News.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/role",
    name: "Role",
    component: Role,
  },
  {
    path: "/video",
    name: "Video",
    component: Video,
  },
  {
    path: "/news",
    name: "News",
    component: News,
  },
];

const router = new VueRouter({
  routes,
});

export default router;